import styled, { css } from 'styled-components'
import { StatusType } from './StatusIcon'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  & > span {
    /* margin-top: 4px; */
    font-size: ${props => props.theme?.font?.small};
    color: #827c8d;
    margin-left: ${props => props.theme.spacing.large};
    @media screen and (max-width: 768px) {
      margin-left: ${props => props.theme.spacing.xlarge};
    }
  }
`

export const StatusWrapper = styled.div`
  gap: 0.5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  border-radius: 4px;

  @media screen and (max-width: 768px) {
    padding: 2px 10px;
  }

  p {
    font-weight: 500;
    margin: 0;
    padding: 0;
    white-space: nowrap;

    @media screen and (max-width: 768px) {
      font-weight: normal;
    }
  }

  img {
    margin-right: 0.5rem;
  }
`

const ICON_SIZE = '16px'

export const StatusIconWrapper = styled.div`
  height: ${ICON_SIZE};
  width: ${ICON_SIZE};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Circle = styled.span<{ type: StatusType; isInnerCircle?: boolean }>`
  position: absolute;
  border-radius: 100%;
  ${props => statusIcons[props?.type || 'waiting'][props?.isInnerCircle ? 'innerCircle' : 'outerCircle']}
`

const statusIcons = {
  everythingOK: {
    innerCircle: () =>
      css`
        height: 8px;
        width: 8px;
        background-color: #22ba46;
      `,
    outerCircle: () =>
      css`
        height: ${ICON_SIZE};
        width: ${ICON_SIZE};
        background-color: #d8fbd2;
      `,
  },
  waiting: {
    innerCircle: () =>
      css`
        height: 8px;
        width: 8px;
        background-color: #ffa61c;
      `,
    outerCircle: () =>
      css`
        height: ${ICON_SIZE};
        width: ${ICON_SIZE};
        background-color: #ffdb8d;
      `,
  },
  past: {
    innerCircle: () =>
      css`
        height: 8px;
        width: 8px;
        background-color: #625e6a;
      `,
    outerCircle: () =>
      css`
        height: ${ICON_SIZE};
        width: ${ICON_SIZE};
        background-color: #d7d3df;
      `,
  },
  none: {
    innerCircle: () =>
      css`
        height: 8px;
        width: 8px;
        background-color: #d7d3df;
      `,
    outerCircle: () =>
      css`
        height: ${ICON_SIZE};
        width: ${ICON_SIZE};
        background-color: #827c8d;
      `,
  },
  all: {
    innerCircle: () =>
      css`
        height: 8px;
        width: 8px;
        background-color: #5558ff;
      `,
    outerCircle: () =>
      css`
        height: ${ICON_SIZE};
        width: ${ICON_SIZE};
        background-color: #ddddff;
      `,
  },
}
